const Templates = [
    {
        "Name": "Logo Left Aligned",
        "IsDefault": true,
        "Type": "offers",
        "Document": {
            "Config": {
                "Style": {
                    "paddingTop": "20px",
                    "paddingBottom": "40px",
                    "paddingLeft": "40px",
                    "paddingRight": "40px"
                },
                "PDF": {
                    "pageMarginTop": "10",
                    "pageMarginBottom": "10",
                    "pageMarginLeft": "10",
                    "pageMarginRight": "10",
                    "footer": true
                }
            },
            "Id": "documentSettings"
        },
        "Blocks": [
            {
                "Id": "columnsTwo-header-default",
                "Type": "columnsTwo",
                "Config": {
                    "Block": {
                        "renderOnlyFirst": false,
                        "col1_width": "66%",
                        "col1_verticalAlign": "top",
                        "col1_collapseIfEmpty": false,
                        "col2_width": "",
                        "col2_verticalAlign": "top",
                        "col2_collapseIfEmpty": false
                    },
                    "Header": {
                        "renderHeaderOnlyFirst": false,
                        "col1_style": "body",
                        "col1_fontStyle": "normal",
                        "col1_verticalAlign": "middle",
                        "col1_textAlign": "left",
                        "col2_style": "body",
                        "col2_fontStyle": "normal",
                        "col2_verticalAlign": "middle",
                        "col2_textAlign": "left"
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px"
                    }
                },
                "Columns": [
                    [
                        {
                            "Id": "logo-default",
                            "Type": "logo",
                            "Config": {
                                "Block": {
                                    "maxWidth": "100%",
                                    "maxHeight": "75px"
                                },
                                "Style": {
                                    "textAlign": "left"
                                }
                            }
                        }
                    ],
                    [
                        {
                            "Id": "companyAddress-default",
                            "Type": "companyAddress",
                            "Config": {
                                "Block": {
                                    "styleCompany": "header",
                                    "colorCompany": "#434343",
                                    "fontSizeCompany": "16px",
                                    "lineHeightCompany": "22px",
                                    "fontStyleCompany": "normal",
                                    "textTransformCompany": "none",
                                    "styleAddress": "body",
                                    "colorAddress": "#949494",
                                    "fontSizeAddress": "12px",
                                    "lineHeightAddress": "18px",
                                    "fontStyleAddress": "normal",
                                    "textTransformAddress": "none"
                                },
                                "Includes": {
                                    "Company": true,
                                    "Phone": true,
                                    "Website": true
                                },
                                "Style": {
                                    "paddingBottom": "6px",
                                    "textAlign": "right"
                                }
                            }
                        }
                    ]
                ]
            },
            {
                "Id": "separator-default",
                "Type": "separator",
                "Config": {
                    "Block": {
                        "renderOnlyFirst": false,
                        "color": "#e9e9e9"
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px"
                    }
                }
            },
            {
                "Id": "columnsTwo-default",
                "Type": "columnsTwo",
                "Config": {
                    "Block": {
                        "renderOnlyFirst": false,
                        "col1_width": "50%",
                        "col1_verticalAlign": "top",
                        "col1_collapseIfEmpty": false,
                        "col2_width": "50%",
                        "col2_verticalAlign": "top",
                        "col2_collapseIfEmpty": false
                    },
                    "Header": {
                        "renderHeaderOnlyFirst": false,
                        "col1_style": "body",
                        "col1_fontStyle": "normal",
                        "col1_verticalAlign": "middle",
                        "col1_textAlign": "left",
                        "col2_style": "body",
                        "col2_fontStyle": "normal",
                        "col2_verticalAlign": "middle",
                        "col2_textAlign": "left"
                    },
                    "Style": {
                        "paddingBottom": "20px"
                    }
                },
                "Columns": [
                    [
                        {
                            "Id": "contactName-default",
                            "Type": "contactName",
                            "Config": {
                                "Block": {
                                    "displayType": "rows",
                                    "textLabel": "Prepared For: ",
                                    "styleLabel": "header",
                                    "fontSizeLabel": "16px",
                                    "lineHeightLabel": "19px",
                                    "fontWeightLabel": "bold",
                                    "fontStyleLabel": "normal",
                                    "textAlignLabel": "left",
                                    "styleValue": "body",
                                    "fontSizeValue": "16px",
                                    "lineHeightValue": "19px",
                                    "fontStyleValue": "normal",
                                    "textTransformValue": "none",
                                    "textAlignValue": "left"
                                },
                                "Style": {
                                    "textAlign": "left"
                                }
                            }
                        },
                        {
                            "Id": "contactCompany-default",
                            "Type": "contactCompany",
                            "Config": {
                                "Block": {
                                    "displayType": "inline",
                                    "styleLabel": "body",
                                    "fontStyleLabel": "normal",
                                    "textAlignLabel": "left",
                                    "styleValue": "body",
                                    "fontSizeValue": "16px",
                                    "lineHeightValue": "19px",
                                    "fontStyleValue": "normal",
                                    "textTransformValue": "none",
                                    "textAlignValue": "left"
                                },
                                "Style": {
                                    "textAlign": "left"
                                }
                            }
                        },
                        {
                            "Id": "staff-default",
                            "Type": "staff",
                            "Config": {
                                "Block": {
                                    "displayType": "rows",
                                    "textLabel": "Prepared By: ",
                                    "styleLabel": "header",
                                    "fontSizeLabel": "16px",
                                    "lineHeightLabel": "19px",
                                    "fontWeightLabel": "bold",
                                    "fontStyleLabel": "normal",
                                    "textAlignLabel": "left",
                                    "styleValue": "body",
                                    "fontSizeValue": "16px",
                                    "lineHeightValue": "19px",
                                    "fontStyleValue": "normal",
                                    "textTransformValue": "none",
                                    "textAlignValue": "left"
                                },
                                "Visibility": {
                                    "Staff": true
                                },
                                "Style": {
                                    "textAlign": "left"
                                }
                            }
                        }
                    ],
                    [
                        {
                            "Id": "date-default",
                            "Type": "date",
                            "Config": {
                                "Block": {
                                    "displayType": "inline",
                                    "textLabel": "Date: ",
                                    "styleLabel": "body",
                                    "fontSizeLabel": "16px",
                                    "lineHeightLabel": "19px",
                                    "fontStyleLabel": "normal",
                                    "textAlignLabel": "left",
                                    "styleValue": "body",
                                    "fontSizeValue": "16px",
                                    "lineHeightValue": "19px",
                                    "fontStyleValue": "normal",
                                    "textTransformValue": "none",
                                    "textAlignValue": "left"
                                },
                                "Style": {
                                    "textAlign": "right"
                                }
                            }
                        },
                        {
                            "Id": "validThrough-default",
                            "Type": "validThrough",
                            "Config": {
                                "Block": {
                                    "displayType": "inline",
                                    "textLabel": "Valid Through: ",
                                    "styleLabel": "body",
                                    "fontSizeLabel": "16px",
                                    "lineHeightLabel": "19px",
                                    "fontStyleLabel": "normal",
                                    "textAlignLabel": "left",
                                    "styleValue": "body",
                                    "fontSizeValue": "16px",
                                    "lineHeightValue": "19px",
                                    "fontStyleValue": "normal",
                                    "textTransformValue": "none",
                                    "textAlignValue": "left"
                                },
                                "Style": {
                                    "textAlign": "right"
                                }
                            }
                        }
                    ]
                ]
            },
            {
                "Id": "lineItems-default",
                "Type": "lineItems",
                "Config": {
                    "Block": {
                        "styleTableHeader": "header",
                        "fontSizeTableHeader": "16px",
                        "lineHeightTableHeader": "29px",
                        "fontStyleTableHeader": "normal",
                        "textTransformTableHeader": "none",
                        "lineSpacingTableHeader": "",
                        "backgroundColorTableHeader": "#eaeaea",
                        "lineItemSpacing": "15px",
                        "columnSpacing": "15px",
                        "marginLeft": "5px",
                        "marginRight": "5px",
                        "borderTopSpacing": "10px",
                        "fontWeightTableHeader": "bold"
                    },
                    "Meta": {
                        "styleArtist": "body",
                        "fontStyleArtist": "normal",
                        "textTransformArtist": "none",
                        "styleTitle": "body",
                        "textTransformTitle": "none",
                        "styleMedium": "body",
                        "fontStyleMedium": "normal",
                        "textTransformMedium": "none",
                        "styleDimensions": "body",
                        "fontStyleDimensions": "normal",
                        "styleSKU": "body",
                        "fontStyleSKU": "normal",
                        "stylePrice": "body",
                        "fontStylePrice": "normal",
                        "styleDiscount": "body",
                        "fontStyleDiscount": "normal",
                        "textZeroDiscount": "",
                        "styleSubtotal": "body",
                        "fontStyleSubtotal": "normal",
                        "fontSizeSubtotal": "16px",
                        "lineHeightSubtotal": "19px",
                        "fontSizeDiscount": "16px",
                        "lineHeightDiscount": "19px",
                        "fontSizePrice": "16px",
                        "lineHeightPrice": "19px",
                        "fontSizeSKU": "16px",
                        "lineHeightSKU": "19px",
                        "fontSizeDimensions": "16px",
                        "lineHeightDimensions": "19px",
                        "fontSizeMedium": "16px",
                        "lineHeightMedium": "19px",
                        "fontSizeTitle": "16px",
                        "lineHeightTitle": "19px",
                        "fontSizeArtist": "16px",
                        "lineHeightArtist": "19px",
                        "fontWeightArtist": "bold"
                    },
                    "Includes": {
                        "TableHeader": true,
                        "Date": true,
                        "Medium": true,
                        "Dimensions": true,
                        "Number": true,
                        "SKU": true
                    },
                    "Style": {
                        "paddingBottom": "5px"
                    },
                    "Format": {
                        "currencyFormatPriceFirst": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatPrice": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatDiscountFirst": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatDiscount": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "percentFormatDiscountFirst": "-[Value]%",
                        "percentFormatDiscount": "-[Value]%",
                        "currencyFormatSubtotalFirst": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatSubtotal": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "discount-default",
                "Type": "discount",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "textLabel": "Discount",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "lineHeightLabel": "19px",
                        "fontWeightLabel": "bold",
                        "fontStyleLabel": "normal",
                        "textAlignLabel": "right",
                        "paddingRightLabel": "5px",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "19px",
                        "fontStyleValue": "normal",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "paddingRightValue": "5px"
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "5px",
                        "textAlign": "left"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "percentFormat": "-[Value]%"
                    }
                }
            },
            {
                "Id": "taxes-default",
                "Type": "taxes",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "rowSpacing": "10px",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "lineHeightLabel": "19px",
                        "fontWeightLabel": "bold",
                        "fontStyleLabel": "normal",
                        "textTransformLabel": "none",
                        "columnWidthLabel": "",
                        "textAlignLabel": "right",
                        "paddingRightLabel": "5px",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "19px",
                        "fontStyleValue": "normal",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "paddingRightValue": "5px"
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "5px",
                        "textAlign": "left"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "shipping-default",
                "Type": "shipping",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "textLabel": "Shipping",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "lineHeightLabel": "19px",
                        "fontWeightLabel": "bold",
                        "fontStyleLabel": "normal",
                        "textAlignLabel": "right",
                        "paddingRightLabel": "5px",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "19px",
                        "fontStyleValue": "normal",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "paddingRightValue": "5px"
                    },
                    "Includes": {
                        "ShippingZero": true
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "5px",
                        "textAlign": "left"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "grandTotal-default",
                "Type": "grandTotal",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "textLabel": "Total",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "lineHeightLabel": "19px",
                        "fontWeightLabel": "bold",
                        "fontStyleLabel": "normal",
                        "textAlignLabel": "right",
                        "paddingRightLabel": "5px",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "19px",
                        "fontStyleValue": "normal",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "paddingRightValue": "5px",
                        "fontWeightValue": "bold"
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "5px",
                        "textAlign": "left"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "notes-default",
                "Type": "notes",
                "Config": {
                    "Block": {
                        "textLabelHeader": "Notes",
                        "styleHeader": "body",
                        "fontSizeHeader": "16px",
                        "lineHeightHeader": "19px",
                        "fontWeightHeader": "bold",
                        "fontStyleHeader": "normal",
                        "styleNote": "body",
                        "fontSizeNote": "16px",
                        "lineHeightNote": "19px",
                        "fontStyleNote": "normal",
                        "textTransformNote": "none"
                    },
                    "Includes": {
                        "HeaderLabel": true
                    },
                    "Style": {
                        "textAlign": "left"
                    }
                }
            }
        ]
    },
    {
        "Name": "Logo Right Aligned",
        "IsDefault": false,
        "Type": "offers",
        "Document": {
            "Config": {
                "Style": {
                    "paddingTop": "20px",
                    "paddingBottom": "40px",
                    "paddingLeft": "40px",
                    "paddingRight": "40px"
                },
                "PDF": {
                    "pageMarginTop": "10",
                    "pageMarginBottom": "10",
                    "pageMarginLeft": "10",
                    "pageMarginRight": "10",
                    "footer": true
                }
            },
            "Id": "documentSettings"
        },
        "Blocks": [
            {
                "Id": "columnsTwo-header-default",
                "Type": "columnsTwo",
                "Config": {
                    "Block": {
                        "renderOnlyFirst": false,
                        "col1_width": "",
                        "col1_verticalAlign": "top",
                        "col1_collapseIfEmpty": false,
                        "col2_width": "66%",
                        "col2_verticalAlign": "top",
                        "col2_collapseIfEmpty": false
                    },
                    "Header": {
                        "renderHeaderOnlyFirst": false,
                        "col1_style": "body",
                        "col1_fontStyle": "normal",
                        "col1_verticalAlign": "middle",
                        "col1_textAlign": "left",
                        "col2_style": "body",
                        "col2_fontStyle": "normal",
                        "col2_verticalAlign": "middle",
                        "col2_textAlign": "left"
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px"
                    }
                },
                "Columns": [
                    [
                        {
                            "Id": "companyAddress-default",
                            "Type": "companyAddress",
                            "Config": {
                                "Block": {
                                    "styleCompany": "header",
                                    "colorCompany": "#434343",
                                    "fontSizeCompany": "16px",
                                    "lineHeightCompany": "22px",
                                    "fontStyleCompany": "normal",
                                    "textTransformCompany": "none",
                                    "styleAddress": "body",
                                    "colorAddress": "#949494",
                                    "fontSizeAddress": "12px",
                                    "lineHeightAddress": "18px",
                                    "fontStyleAddress": "normal",
                                    "textTransformAddress": "none"
                                },
                                "Includes": {
                                    "Company": true,
                                    "Phone": true,
                                    "Website": true
                                },
                                "Style": {
                                    "paddingBottom": "6px",
                                    "textAlign": "left"
                                }
                            }
                        }
                    ],
                    [
                        {
                            "Id": "logo-default",
                            "Type": "logo",
                            "Config": {
                                "Block": {
                                    "maxWidth": "100%",
                                    "maxHeight": "75px"
                                },
                                "Style": {
                                    "textAlign": "right"
                                }
                            }
                        }
                    ]
                ]
            },
            {
                "Id": "separator-default",
                "Type": "separator",
                "Config": {
                    "Block": {
                        "renderOnlyFirst": false,
                        "color": "#e9e9e9"
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px"
                    }
                }
            },
            {
                "Id": "columnsTwo-default",
                "Type": "columnsTwo",
                "Config": {
                    "Block": {
                        "renderOnlyFirst": false,
                        "col1_width": "50%",
                        "col1_verticalAlign": "top",
                        "col1_collapseIfEmpty": false,
                        "col2_width": "50%",
                        "col2_verticalAlign": "top",
                        "col2_collapseIfEmpty": false
                    },
                    "Header": {
                        "renderHeaderOnlyFirst": false,
                        "col1_style": "body",
                        "col1_fontStyle": "normal",
                        "col1_verticalAlign": "middle",
                        "col1_textAlign": "left",
                        "col2_style": "body",
                        "col2_fontStyle": "normal",
                        "col2_verticalAlign": "middle",
                        "col2_textAlign": "left"
                    },
                    "Style": {
                        "paddingBottom": "20px"
                    }
                },
                "Columns": [
                    [
                        {
                            "Id": "contactName-default",
                            "Type": "contactName",
                            "Config": {
                                "Block": {
                                    "displayType": "rows",
                                    "textLabel": "Prepared For: ",
                                    "styleLabel": "header",
                                    "fontSizeLabel": "16px",
                                    "lineHeightLabel": "19px",
                                    "fontWeightLabel": "bold",
                                    "fontStyleLabel": "normal",
                                    "textAlignLabel": "left",
                                    "styleValue": "body",
                                    "fontSizeValue": "16px",
                                    "lineHeightValue": "19px",
                                    "fontStyleValue": "normal",
                                    "textTransformValue": "none",
                                    "textAlignValue": "left"
                                },
                                "Style": {
                                    "textAlign": "left"
                                }
                            }
                        },
                        {
                            "Id": "contactCompany-default",
                            "Type": "contactCompany",
                            "Config": {
                                "Block": {
                                    "displayType": "inline",
                                    "styleLabel": "body",
                                    "fontStyleLabel": "normal",
                                    "textAlignLabel": "left",
                                    "styleValue": "body",
                                    "fontSizeValue": "16px",
                                    "lineHeightValue": "19px",
                                    "fontStyleValue": "normal",
                                    "textTransformValue": "none",
                                    "textAlignValue": "left"
                                },
                                "Style": {
                                    "textAlign": "left"
                                }
                            }
                        },
                        {
                            "Id": "staff-default",
                            "Type": "staff",
                            "Config": {
                                "Block": {
                                    "displayType": "rows",
                                    "textLabel": "Prepared By: ",
                                    "styleLabel": "header",
                                    "fontSizeLabel": "16px",
                                    "lineHeightLabel": "19px",
                                    "fontWeightLabel": "bold",
                                    "fontStyleLabel": "normal",
                                    "textAlignLabel": "left",
                                    "styleValue": "body",
                                    "fontSizeValue": "16px",
                                    "lineHeightValue": "19px",
                                    "fontStyleValue": "normal",
                                    "textTransformValue": "none",
                                    "textAlignValue": "left"
                                },
                                "Visibility": {
                                    "Staff": true
                                },
                                "Style": {
                                    "textAlign": "left"
                                }
                            }
                        }
                    ],
                    [
                        {
                            "Id": "date-default",
                            "Type": "date",
                            "Config": {
                                "Block": {
                                    "displayType": "inline",
                                    "textLabel": "Date: ",
                                    "styleLabel": "body",
                                    "fontSizeLabel": "16px",
                                    "lineHeightLabel": "19px",
                                    "fontStyleLabel": "normal",
                                    "textAlignLabel": "left",
                                    "styleValue": "body",
                                    "fontSizeValue": "16px",
                                    "lineHeightValue": "19px",
                                    "fontStyleValue": "normal",
                                    "textTransformValue": "none",
                                    "textAlignValue": "left"
                                },
                                "Style": {
                                    "textAlign": "right"
                                }
                            }
                        },
                        {
                            "Id": "validThrough-default",
                            "Type": "validThrough",
                            "Config": {
                                "Block": {
                                    "displayType": "inline",
                                    "textLabel": "Valid Through: ",
                                    "styleLabel": "body",
                                    "fontSizeLabel": "16px",
                                    "lineHeightLabel": "19px",
                                    "fontStyleLabel": "normal",
                                    "textAlignLabel": "left",
                                    "styleValue": "body",
                                    "fontSizeValue": "16px",
                                    "lineHeightValue": "19px",
                                    "fontStyleValue": "normal",
                                    "textTransformValue": "none",
                                    "textAlignValue": "left"
                                },
                                "Style": {
                                    "textAlign": "right"
                                }
                            }
                        }
                    ]
                ]
            },
            {
                "Id": "lineItems-default",
                "Type": "lineItems",
                "Config": {
                    "Block": {
                        "styleTableHeader": "header",
                        "fontSizeTableHeader": "16px",
                        "lineHeightTableHeader": "29px",
                        "fontStyleTableHeader": "normal",
                        "textTransformTableHeader": "none",
                        "lineSpacingTableHeader": "",
                        "backgroundColorTableHeader": "#eaeaea",
                        "lineItemSpacing": "15px",
                        "columnSpacing": "15px",
                        "marginLeft": "5px",
                        "marginRight": "5px",
                        "borderTopSpacing": "10px",
                        "fontWeightTableHeader": "bold"
                    },
                    "Meta": {
                        "styleArtist": "body",
                        "fontStyleArtist": "normal",
                        "textTransformArtist": "none",
                        "styleTitle": "body",
                        "textTransformTitle": "none",
                        "styleMedium": "body",
                        "fontStyleMedium": "normal",
                        "textTransformMedium": "none",
                        "styleDimensions": "body",
                        "fontStyleDimensions": "normal",
                        "styleSKU": "body",
                        "fontStyleSKU": "normal",
                        "stylePrice": "body",
                        "fontStylePrice": "normal",
                        "styleDiscount": "body",
                        "fontStyleDiscount": "normal",
                        "textZeroDiscount": "",
                        "styleSubtotal": "body",
                        "fontStyleSubtotal": "normal",
                        "fontSizeSubtotal": "16px",
                        "lineHeightSubtotal": "19px",
                        "fontSizeDiscount": "16px",
                        "lineHeightDiscount": "19px",
                        "fontSizePrice": "16px",
                        "lineHeightPrice": "19px",
                        "fontSizeSKU": "16px",
                        "lineHeightSKU": "19px",
                        "fontSizeDimensions": "16px",
                        "lineHeightDimensions": "19px",
                        "fontSizeMedium": "16px",
                        "lineHeightMedium": "19px",
                        "fontSizeTitle": "16px",
                        "lineHeightTitle": "19px",
                        "fontSizeArtist": "16px",
                        "lineHeightArtist": "19px",
                        "fontWeightArtist": "bold"
                    },
                    "Includes": {
                        "TableHeader": true,
                        "Date": true,
                        "Medium": true,
                        "Dimensions": true,
                        "Number": true,
                        "SKU": true
                    },
                    "Style": {
                        "paddingBottom": "5px"
                    },
                    "Format": {
                        "currencyFormatPriceFirst": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatPrice": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatDiscountFirst": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatDiscount": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "percentFormatDiscountFirst": "-[Value]%",
                        "percentFormatDiscount": "-[Value]%",
                        "currencyFormatSubtotalFirst": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatSubtotal": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "discount-default",
                "Type": "discount",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "textLabel": "Discount",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "lineHeightLabel": "19px",
                        "fontWeightLabel": "bold",
                        "fontStyleLabel": "normal",
                        "textAlignLabel": "right",
                        "paddingRightLabel": "5px",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "19px",
                        "fontStyleValue": "normal",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "paddingRightValue": "5px"
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "5px",
                        "textAlign": "left"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "percentFormat": "-[Value]%"
                    }
                }
            },
            {
                "Id": "taxes-default",
                "Type": "taxes",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "rowSpacing": "10px",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "lineHeightLabel": "19px",
                        "fontWeightLabel": "bold",
                        "fontStyleLabel": "normal",
                        "textTransformLabel": "none",
                        "columnWidthLabel": "",
                        "textAlignLabel": "right",
                        "paddingRightLabel": "5px",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "19px",
                        "fontStyleValue": "normal",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "paddingRightValue": "5px"
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "5px",
                        "textAlign": "left"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "shipping-default",
                "Type": "shipping",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "textLabel": "Shipping",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "lineHeightLabel": "19px",
                        "fontWeightLabel": "bold",
                        "fontStyleLabel": "normal",
                        "textAlignLabel": "right",
                        "paddingRightLabel": "5px",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "19px",
                        "fontStyleValue": "normal",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "paddingRightValue": "5px"
                    },
                    "Includes": {
                        "ShippingZero": true
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "5px",
                        "textAlign": "left"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "grandTotal-default",
                "Type": "grandTotal",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "textLabel": "Total",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "lineHeightLabel": "19px",
                        "fontWeightLabel": "bold",
                        "fontStyleLabel": "normal",
                        "textAlignLabel": "right",
                        "paddingRightLabel": "5px",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "19px",
                        "fontStyleValue": "normal",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "paddingRightValue": "5px",
                        "fontWeightValue": "bold"
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "5px",
                        "textAlign": "left"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "notes-default",
                "Type": "notes",
                "Config": {
                    "Block": {
                        "textLabelHeader": "Notes",
                        "styleHeader": "body",
                        "fontSizeHeader": "16px",
                        "lineHeightHeader": "19px",
                        "fontWeightHeader": "bold",
                        "fontStyleHeader": "normal",
                        "styleNote": "body",
                        "fontSizeNote": "16px",
                        "lineHeightNote": "19px",
                        "fontStyleNote": "normal",
                        "textTransformNote": "none"
                    },
                    "Includes": {
                        "HeaderLabel": true
                    },
                    "Style": {
                        "textAlign": "left"
                    }
                }
            }
        ]
    },
    {
        "Name": "Logo Centered",
        "IsDefault": false,
        "Type": "offers",
        "Document": {
            "Config": {
                "Style": {
                    "paddingTop": "20px",
                    "paddingBottom": "40px",
                    "paddingLeft": "40px",
                    "paddingRight": "40px"
                },
                "PDF": {
                    "pageMarginTop": "10",
                    "pageMarginBottom": "10",
                    "pageMarginLeft": "10",
                    "pageMarginRight": "10",
                    "footer": true
                }
            },
            "Id": "documentSettings"
        },
        "Blocks": [
            {
                "Id": "logo-default",
                "Type": "logo",
                "Config": {
                    "Block": {
                        "maxWidth": "100%",
                        "maxHeight": "75px"
                    },
                    "Style": {
                        "textAlign": "center",
                        "paddingTop": "20px",
                        "paddingBottom": "14px"
                    }
                }
            },
            {
                "Id": "separator-default",
                "Type": "separator",
                "Config": {
                    "Block": {
                        "renderOnlyFirst": false,
                        "color": "#e9e9e9"
                    },
                    "Style": {
                        "paddingTop": "20px",
                        "paddingBottom": "20px"
                    }
                }
            },
            {
                "Id": "columnsTwo-default",
                "Type": "columnsTwo",
                "Config": {
                    "Block": {
                        "renderOnlyFirst": false,
                        "col1_width": "50%",
                        "col1_verticalAlign": "top",
                        "col1_collapseIfEmpty": false,
                        "col2_width": "50%",
                        "col2_verticalAlign": "top",
                        "col2_collapseIfEmpty": false
                    },
                    "Header": {
                        "renderHeaderOnlyFirst": false,
                        "col1_style": "body",
                        "col1_fontStyle": "normal",
                        "col1_verticalAlign": "middle",
                        "col1_textAlign": "left",
                        "col2_style": "body",
                        "col2_fontStyle": "normal",
                        "col2_verticalAlign": "middle",
                        "col2_textAlign": "left"
                    },
                    "Style": {
                        "paddingBottom": "20px"
                    }
                },
                "Columns": [
                    [
                        {
                            "Id": "contactName-default",
                            "Type": "contactName",
                            "Config": {
                                "Block": {
                                    "displayType": "rows",
                                    "textLabel": "Prepared For: ",
                                    "styleLabel": "header",
                                    "fontSizeLabel": "16px",
                                    "lineHeightLabel": "19px",
                                    "fontWeightLabel": "bold",
                                    "fontStyleLabel": "normal",
                                    "textAlignLabel": "left",
                                    "styleValue": "body",
                                    "fontSizeValue": "16px",
                                    "lineHeightValue": "19px",
                                    "fontStyleValue": "normal",
                                    "textTransformValue": "none",
                                    "textAlignValue": "left"
                                },
                                "Style": {
                                    "textAlign": "left"
                                }
                            }
                        },
                        {
                            "Id": "contactCompany-default",
                            "Type": "contactCompany",
                            "Config": {
                                "Block": {
                                    "displayType": "inline",
                                    "styleLabel": "body",
                                    "fontStyleLabel": "normal",
                                    "textAlignLabel": "left",
                                    "styleValue": "body",
                                    "fontSizeValue": "16px",
                                    "lineHeightValue": "19px",
                                    "fontStyleValue": "normal",
                                    "textTransformValue": "none",
                                    "textAlignValue": "left"
                                },
                                "Style": {
                                    "textAlign": "left"
                                }
                            }
                        },
                        {
                            "Id": "staff-default",
                            "Type": "staff",
                            "Config": {
                                "Block": {
                                    "displayType": "rows",
                                    "textLabel": "Prepared By: ",
                                    "styleLabel": "header",
                                    "fontSizeLabel": "16px",
                                    "lineHeightLabel": "19px",
                                    "fontWeightLabel": "bold",
                                    "fontStyleLabel": "normal",
                                    "textAlignLabel": "left",
                                    "styleValue": "body",
                                    "fontSizeValue": "16px",
                                    "lineHeightValue": "19px",
                                    "fontStyleValue": "normal",
                                    "textTransformValue": "none",
                                    "textAlignValue": "left"
                                },
                                "Visibility": {
                                    "Staff": true
                                },
                                "Style": {
                                    "textAlign": "left"
                                }
                            }
                        }
                    ],
                    [
                        {
                            "Id": "date-default",
                            "Type": "date",
                            "Config": {
                                "Block": {
                                    "displayType": "inline",
                                    "textLabel": "Date: ",
                                    "styleLabel": "body",
                                    "fontSizeLabel": "16px",
                                    "lineHeightLabel": "19px",
                                    "fontStyleLabel": "normal",
                                    "textAlignLabel": "left",
                                    "styleValue": "body",
                                    "fontSizeValue": "16px",
                                    "lineHeightValue": "19px",
                                    "fontStyleValue": "normal",
                                    "textTransformValue": "none",
                                    "textAlignValue": "left"
                                },
                                "Style": {
                                    "textAlign": "right"
                                }
                            }
                        },
                        {
                            "Id": "validThrough-default",
                            "Type": "validThrough",
                            "Config": {
                                "Block": {
                                    "displayType": "inline",
                                    "textLabel": "Valid Through: ",
                                    "styleLabel": "body",
                                    "fontSizeLabel": "16px",
                                    "lineHeightLabel": "19px",
                                    "fontStyleLabel": "normal",
                                    "textAlignLabel": "left",
                                    "styleValue": "body",
                                    "fontSizeValue": "16px",
                                    "lineHeightValue": "19px",
                                    "fontStyleValue": "normal",
                                    "textTransformValue": "none",
                                    "textAlignValue": "left"
                                },
                                "Style": {
                                    "textAlign": "right"
                                }
                            }
                        }
                    ]
                ]
            },
            {
                "Id": "lineItems-default",
                "Type": "lineItems",
                "Config": {
                    "Block": {
                        "styleTableHeader": "header",
                        "fontSizeTableHeader": "16px",
                        "lineHeightTableHeader": "29px",
                        "fontStyleTableHeader": "normal",
                        "textTransformTableHeader": "none",
                        "lineSpacingTableHeader": "",
                        "backgroundColorTableHeader": "#eaeaea",
                        "lineItemSpacing": "15px",
                        "columnSpacing": "15px",
                        "marginLeft": "5px",
                        "marginRight": "5px",
                        "borderTopSpacing": "10px",
                        "fontWeightTableHeader": "bold"
                    },
                    "Meta": {
                        "styleArtist": "body",
                        "fontStyleArtist": "normal",
                        "textTransformArtist": "none",
                        "styleTitle": "body",
                        "textTransformTitle": "none",
                        "styleMedium": "body",
                        "fontStyleMedium": "normal",
                        "textTransformMedium": "none",
                        "styleDimensions": "body",
                        "fontStyleDimensions": "normal",
                        "styleSKU": "body",
                        "fontStyleSKU": "normal",
                        "stylePrice": "body",
                        "fontStylePrice": "normal",
                        "styleDiscount": "body",
                        "fontStyleDiscount": "normal",
                        "textZeroDiscount": "",
                        "styleSubtotal": "body",
                        "fontStyleSubtotal": "normal",
                        "fontSizeSubtotal": "16px",
                        "lineHeightSubtotal": "19px",
                        "fontSizeDiscount": "16px",
                        "lineHeightDiscount": "19px",
                        "fontSizePrice": "16px",
                        "lineHeightPrice": "19px",
                        "fontSizeSKU": "16px",
                        "lineHeightSKU": "19px",
                        "fontSizeDimensions": "16px",
                        "lineHeightDimensions": "19px",
                        "fontSizeMedium": "16px",
                        "lineHeightMedium": "19px",
                        "fontSizeTitle": "16px",
                        "lineHeightTitle": "19px",
                        "fontSizeArtist": "16px",
                        "lineHeightArtist": "19px",
                        "fontWeightArtist": "bold"
                    },
                    "Includes": {
                        "TableHeader": true,
                        "Date": true,
                        "Medium": true,
                        "Dimensions": true,
                        "Number": true,
                        "SKU": true
                    },
                    "Style": {
                        "paddingBottom": "5px"
                    },
                    "Format": {
                        "currencyFormatPriceFirst": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatPrice": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatDiscountFirst": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatDiscount": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "percentFormatDiscountFirst": "-[Value]%",
                        "percentFormatDiscount": "-[Value]%",
                        "currencyFormatSubtotalFirst": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "currencyFormatSubtotal": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "discount-default",
                "Type": "discount",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "textLabel": "Discount",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "lineHeightLabel": "19px",
                        "fontWeightLabel": "bold",
                        "fontStyleLabel": "normal",
                        "textAlignLabel": "right",
                        "paddingRightLabel": "5px",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "19px",
                        "fontStyleValue": "normal",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "paddingRightValue": "5px"
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "5px",
                        "textAlign": "left"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00",
                        "percentFormat": "-[Value]%"
                    }
                }
            },
            {
                "Id": "taxes-default",
                "Type": "taxes",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "rowSpacing": "10px",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "lineHeightLabel": "19px",
                        "fontWeightLabel": "bold",
                        "fontStyleLabel": "normal",
                        "textTransformLabel": "none",
                        "columnWidthLabel": "",
                        "textAlignLabel": "right",
                        "paddingRightLabel": "5px",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "19px",
                        "fontStyleValue": "normal",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "paddingRightValue": "5px"
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "5px",
                        "textAlign": "left"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "shipping-default",
                "Type": "shipping",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "textLabel": "Shipping",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "lineHeightLabel": "19px",
                        "fontWeightLabel": "bold",
                        "fontStyleLabel": "normal",
                        "textAlignLabel": "right",
                        "paddingRightLabel": "5px",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "19px",
                        "fontStyleValue": "normal",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "paddingRightValue": "5px"
                    },
                    "Includes": {
                        "ShippingZero": true
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "5px",
                        "textAlign": "left"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "grandTotal-default",
                "Type": "grandTotal",
                "Config": {
                    "Block": {
                        "displayType": "columns",
                        "textLabel": "Total",
                        "styleLabel": "header",
                        "fontSizeLabel": "16px",
                        "lineHeightLabel": "19px",
                        "fontWeightLabel": "bold",
                        "fontStyleLabel": "normal",
                        "textAlignLabel": "right",
                        "paddingRightLabel": "5px",
                        "styleValue": "body",
                        "fontSizeValue": "16px",
                        "lineHeightValue": "19px",
                        "fontStyleValue": "normal",
                        "columnWidthValue": "15%",
                        "textAlignValue": "right",
                        "paddingRightValue": "5px",
                        "fontWeightValue": "bold"
                    },
                    "Style": {
                        "paddingTop": "5px",
                        "paddingBottom": "5px",
                        "textAlign": "left"
                    },
                    "Format": {
                        "currencyFormat": "[CurrencySymbol]1[ThousandsSep]000[DecimalSep]00"
                    }
                }
            },
            {
                "Id": "notes-default",
                "Type": "notes",
                "Config": {
                    "Block": {
                        "textLabelHeader": "Notes",
                        "styleHeader": "body",
                        "fontSizeHeader": "16px",
                        "lineHeightHeader": "19px",
                        "fontWeightHeader": "bold",
                        "fontStyleHeader": "normal",
                        "styleNote": "body",
                        "fontSizeNote": "16px",
                        "lineHeightNote": "19px",
                        "fontStyleNote": "normal",
                        "textTransformNote": "none"
                    },
                    "Includes": {
                        "HeaderLabel": true
                    },
                    "Style": {
                        "textAlign": "left"
                    }
                }
            }
        ]
    }
];

module.exports = Templates;